import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';

import { PimaProject } from '../shared/model/pima-project';
import { UnsubscribeActions } from '../state/unsubscribe/actions';

const PARAM_PROJECT_ID = "project_id";

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnsubscribeComponent implements OnInit {

  @Select(state => state.unsubscribe.projectInfo) projectInfo$: Observable<PimaProject>;
  @Select(state => state.unsubscribe.error) error$: Observable<string>;
  @Select(state => state.unsubscribe.message) message$: Observable<string>;

  unsubForm = new FormGroup({
    projectSelect: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor(
    private route: ActivatedRoute,
    private store: Store,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      if (queryParams[PARAM_PROJECT_ID]){
        let projectId = queryParams[PARAM_PROJECT_ID];
        this.store.dispatch(new UnsubscribeActions.GetProjectInfo(+projectId))
      } else {
        this.store.dispatch(new UnsubscribeActions.SetError('Missing Project ID in url...'));
      }
    });

    this.projectInfo$.subscribe(pi => {
      console.log('Project Info', pi);
    })
  }

  reset(){
    this.unsubForm.reset();
    this.store.dispatch(new UnsubscribeActions.ClearErrorAndMessage());
  }

  getEmailErrorMsg() {
    const email = this.unsubForm.get('email');
    if (email.hasError('required')) {
      return 'You must enter a value';
    }

    return email.hasError('email') ? 'Not a valid email' : '';
  }

  unsubscribe(){
    const pId = +this.unsubForm.get('projectSelect').value;
    const email = this.unsubForm.get('email').value;
    const projectId = pId === -1 ? null : pId;
    this.store.dispatch(new UnsubscribeActions.EmailUnsubscribe(email, projectId));
  }

}
